/*
Ilan's Website
Copyright (C) 2024-2026 ILAN ROSENBAUM

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

You should have received a copy of the GNU General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: "ilan-web.firebaseapp.com",
  projectId: "ilan-web",
  storageBucket: "ilan-web.appspot.com",
  messagingSenderId: "870074135993",
  appId: "1:870074135993:web:91b3fabb9cd02cc3153268",
  measurementId: "G-RSBLK5DW2W"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const analytics = getAnalytics(app);
const realtimeDb = getDatabase(app, "https://ilan-web-default-rtdb.firebaseio.com/");

export { app, storage, firebaseConfig, analytics, realtimeDb };
